import { Pipe, PipeTransform } from '@angular/core';

import { MeasurementUnit, MeasurementUnitShort } from '../models';

@Pipe({
  name: 'avsMeasurementUnitDisplay',
})
export class MeasurementUnitDisplayPipe implements PipeTransform {
  transform(measurementUnit: MeasurementUnit | undefined | null): string | null {
    const unit = measurementUnit?.displayShort;

    if (unit && unit !== MeasurementUnitShort.YN && unit !== MeasurementUnitShort.COUNT) {
      return unit;
    }

    return null;
  }
}
